import React, { useState } from "react";

import InProgressTable from "../components/InProgressTable";
import InProgressSearch from "../components/InProgressSearch";
import Grid from "@mui/material/Unstable_Grid2";

const OrdersInProgress = (props) => {
	const [inProgress, setInProgress] = useState([]);
	const [page, setPage] = useState(1);
	const [pageCount, setPageCount] = useState(1);

	//getting the data from search component
	const getOrderData = (data, count) => {
		setInProgress(data);
		setPageCount(count);
	};

	//getting the data from the pagination
	const getPage = (data) => {
		setPage(data);
	};

	return (
		<React.Fragment>
			<Grid container spacing={4}>
				<Grid md={12}>
					<InProgressSearch
						getOrderData={getOrderData}
						page={page}
						rowCount={15}
					/>
				</Grid>
				<Grid md={12}>
					<InProgressTable
						data={inProgress}
						getPage={getPage}
						pageCount={pageCount}
					/>
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default OrdersInProgress;
